import React from 'react';
import '../styles/WhyUs.css';

const WhyUs = () => {
  const valuesData = [
    {
      icon: '🌱',
      title: '100% Ecológico',
      description: 'Utilizamos únicamente productos biodegradables certificados que cuidan el medio ambiente y la salud de las personas.'
    },
    {
      icon: '👥',
      title: 'Personal Capacitado',
      description: 'Equipo profesional con capacitación constante en técnicas modernas de limpieza y protocolos de seguridad.'
    },
    {
      icon: '🏆',
      title: 'Calidad Garantizada',
      description: 'Supervisión continua y estándares de calidad certificados. Garantizamos su satisfacción en cada servicio.'
    },
    {
      icon: '⚡',
      title: 'Tecnología Avanzada',
      description: 'Equipamiento de última generación para resultados superiores y mayor eficiencia en cada proyecto.'
    },
    {
      icon: '🤝',
      title: 'Compromiso Social',
      description: 'Generamos empleo digno y contribuimos al desarrollo sostenible de nuestra comunidad.'
    },
    {
      icon: '📋',
      title: 'Planes Personalizados',
      description: 'Diseñamos soluciones a medida según las necesidades específicas de cada cliente y sector.'
    }
  ];

  return (
    <section className="why-us" id="nosotros">
      <div className="section-title">
        <p className="section-subtitle">Por Qué Elegirnos</p>
        <h2>Nuestros Valores y Compromiso</h2>
      </div>
      <p className="section-description">
        En Ecolimpieza A&G S.A.C., combinamos experiencia, tecnología y responsabilidad ambiental 
        para ofrecer servicios de limpieza de clase mundial.
      </p>
      
      <div className="why-us-container">
        {valuesData.map((value, index) => (
          <div key={index} className="value-card">
            <div className="value-icon">{value.icon}</div>
            <h3>{value.title}</h3>
            <p>{value.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyUs;
